import { UNITLESS_CSS } from '../constants';

function toKebab(key) {
  return key.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
}

function toCssValue(key, value) {
  if (typeof value === 'number' && value !== 0 && !UNITLESS_CSS.has(key)) {
    return `${value}px`;
  }

  return value;
}

function declarations(style) {
  return Object.entries(style)
    .filter(
      ([, value]) =>
        value !== null &&
        value !== undefined &&
        value !== false &&
        typeof value !== 'object'
    )
    .map(([key, value]) => `${toKebab(key)}:${toCssValue(key, value)};`)
    .join('');
}

export function cssObjectToSheet(className, style) {
  if (!style || typeof style !== 'object' || Array.isArray(style)) return '';

  const flat = {};
  let nested = '';

  Object.entries(style).forEach(([key, value]) => {
    if (value && typeof value === 'object' && key.includes('&')) {
      const selector = key.replace(/&/g, `.${className}`);
      const body = declarations(value);

      if (body) nested += `${selector}{${body}}`;
      return;
    }

    flat[key] = value;
  });

  const flatBody = declarations(flat);

  return `${flatBody ? `.${className}{${flatBody}}` : ''}${nested}`;
}
